import { datagridActions } from "../actions/datagrid-actions";
import { filteringActions } from "../actions/filtering-actions";
import { handleActions } from "../utils/redux-helper";

const initialState = {
  columnSearchValues: {},
  columnSearchValuesDisplayAs: {},
  extendedSearchData: [],
  extendedSearchOperator: null,
};

const cleanFilteringState = {
  columnSearchValues: {},
  columnSearchValuesDisplayAs: {},
  extendedSearchData: [],
  extendedSearchOperator: null,
};

const searchReducer = handleActions(
  {
    [datagridActions.REHYDRATE_VALIDATION]: (state) => {
      let filteredState = {};
      Object.keys(initialState).forEach((keyName) => {
        filteredState[keyName] =
          state[keyName] !== undefined ? state[keyName] : initialState[keyName];
      });
      return filteredState;
    },
    [datagridActions.CLEAR_FILTERING]: (state) => {
      return {
        ...state,
        ...cleanFilteringState,
      };
    },
    [datagridActions.CLEAR_CACHE]: (state) => {
      return {
        ...state,
        ...cleanFilteringState,
      };
    },

    [datagridActions.COLUMN_SEARCH]: (state, action) => {
      if (action.searchValue) {
        return {
          ...state,
          columnSearchValues: {
            ...state.columnSearchValues,
            [action.columnName]: action.searchValue,
          },
          columnSearchValuesDisplayAs: {
            ...state.columnSearchValuesDisplayAs,
            ...(action.searchValueDisplayAs
              ? {
                  [action.columnName]: action.searchValueDisplayAs,
                }
              : null),
          },
        };
      } else if (state.columnSearchValues[action.columnName] !== undefined) {
        // If we have an empty search value and we already have
        // defined the fieldName, remove it from search
        // (empty values on quick search shouldn't search for
        // an empty value)
        delete state.columnSearchValues[action.columnName];

        return {
          ...state,
          columnSearchValues: {
            ...state.columnSearchValues,
          },
        };
      }
      // Fallback
      return {
        ...state,
      };
    },

    [filteringActions.FORM_SUBMIT]: (state, action) => {
      return {
        ...state,
        columnSearchValues: {},
        columnSearchValuesDisplayAs: {},
        extendedSearchData: action.data["extended_search"],
        extendedSearchOperator: action.data["basic_operator"],
      };
    },
  },
  {
    ...initialState,
  }
);

export default searchReducer;
